<template>
  <div>
    <page-header
      left-side-class="col-12 col-md-7"
      :page="headerConfig"
      right-side-class="col-12 col-md-5"
      class="mt-3 mt-md-0"
      @onReturn="() => $router.back()"
      :has-return="true"
    />

    <div class="row">
      <div class="col">
        <filter-manager
          :display-advanced="false"
          class="search-bar"
          items-container-class="flex-wrap"
          search-icon="fa fa-sync"
          search-text="Procesar"
          search-container-class="btn-process"
          v-model="model.search.filters"
          :filters="filterManagerConfig"
          @search="onHandlerSearch"
          ref="filterRef"
        />
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from "PageHeader";
import FilterManager from "FilterManager";
import AcademicYearServices from "@/services/api/academicyear.api";
import codeAcademicYear from "@/utils/constants/codeAcademicYear";
import providerServices from "@/services/api/provider.api";
import ReportServices from '@/modules/report/api';
import DocumentServices from '@//modules/report/document'

export default {
  name: "SAEERegisterVisitsReportsVue",
  components: {
    PageHeader,
    FilterManager,
  },
  data: () => ({
    selectedYearMonths: [],
    model: {
     search: {
       filters: {
         academicYear: null,
         scholarSemester: null,
         month: null,
         provider: null
       },
       collections: {
         academicYears: [],
         scholarSemesters: [
           {id: 1, name: "Primer semestre"},
           {id: 2, name: "Segundo semestre"}
         ],
         months: [],
         providers: []
       }
     }
    }
  }),
  computed: {
    headerConfig() {
      return {
        title: 'Reporte Registro de Visitas SAEE',
        icon:
          'fas fa-clipboard-list-check',
        routes: ['Inicio', 'Reporte Registro de Visitas SAEE'],
      }
    },
    filterManagerConfig() {
      return [
        {
          name: 'academicYear',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Año Académico:',
          placeholder: 'Seleccionar',
          error: 'Favor seleccionar un año académico.',
          validations: 'required',
          class: 'col-md-3',
          clearable: false,
          options: this.model.search.collections.academicYears,
          value: this.model.search.filters.academicYear,
          onChanged: this.onChangeAcademicYear,
        },
        {
          name: 'scholarSemester',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Semestre:',
          placeholder: 'Seleccionar',
          error: 'Favor seleccionar un semestre.',
          validations: 'required',
          class: 'col-12 col-md-3',
          clearable: false,
          options: this.model.search.collections.scholarSemesters,
          value: this.model.search.filters.scholarSemester,
          onChanged: this.onChangeSemester,
        },
        {
          name: 'month',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Mes:',
          placeholder: 'Seleccionar',
          class: 'col-md-3',
          disabled: this.isSemesterSelected,
          clearable: true,
          options: this.model.search.collections.months,
          value: this.model.search.filters.month,
          onChanged: this.onChangeMonth,
        },
        {
          name: 'provider',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Proveedor:',
          placeholder: 'Seleccionar',
          class: 'col-12 col-md-3',
          disabled: this.isSemesterSelected,
          clearable: true,
          options: this.model.search.collections.providers,
          value: this.model.search.filters.provider,
        }
      ]
    },
    isSemesterSelected() {
      return !this.model.search.filters.scholarSemester
    }
  },
  async mounted() {
    await this.getAcademicYears();
  },
  methods: {
    async onChangeAcademicYear() {
      await this.getAcademicYearMonths(this.model.search.filters.academicYear.id);
      this.model.search.filters.scholarSemester = null;
      this.model.search.filters.month = null;
      this.model.search.filters.provider = null;
    },
    async onChangeSemester() {
      await this.getAcademicYearProviders(
        this.model.search.filters.academicYear.id,
        this.model.search.filters.scholarSemester.id
      )
      if(this.selectedYearMonths.length === 12 && this.model.search.filters.scholarSemester) {
        this.model.search.collections.months =
          this.model.search.filters.scholarSemester.id === 1
          ? this.selectedYearMonths.slice(0,6)
          : this.selectedYearMonths.slice(7,12)
        this.model.search.filters.month = null;
        this.model.search.filters.provider = null;
      }
    },

    async onChangeMonth() {
      await this.getAcademicYearProviders(
        this.model.search.filters.academicYear.id,
        this.model.search.filters.scholarSemester.id,
        this.model.search.filters.month.id
      );
      this.model.search.filters.provider = null;
    },

    async onHandlerSearch() {
      const isValid = await this.$refs.filterRef.$refs.formValidator.validate()
      if (isValid) {
        await this.process()
      }
    },
    async getAcademicYears() {
      const search = this.model.search
      search.collections.academicYears = (
        await AcademicYearServices.getAcademicYearsFromSpecificYear(
          codeAcademicYear['2016-2017']
        )
      ).data

      search.filters.academicYear = search.collections.academicYears[0];
      await this.getAcademicYearMonths(search.filters.academicYear.id)
    },
    async getAcademicYearMonths(academicYearId) {
      this.selectedYearMonths = (
        await AcademicYearServices.getMonthsInAcademicYear(academicYearId)
      ).data;
    },
    async getAcademicYearProviders(academicYearId, semester, month) {
      this.model.search.collections.providers = (
        await providerServices.getProvidersAvailableWithVisits(academicYearId, semester, month)
      ).data;
    },
    async process() {
      const filters = this.model.search.filters
      await ReportServices.getReport('rpsaeevisitregistry', {
        academicYearId: filters.academicYear.id,
        semester: filters.scholarSemester.id,
        month: filters.month?.id,
        providerId: filters.provider?.id
      }).then((res) => DocumentServices.Download(res.data));
    }
  }
}
</script>
